import { Injectable } from '@angular/core';
import { Http,Response, Headers,RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/catch';
import {Observable} from "rxjs";
import {AuthenticationService} from "../Login/authentication.service";
import {Factura} from "../lista-facturas/factura.interface";
import {UrlService} from "./url.service";




@Injectable()
export class FacturaService
{

  private headers = new Headers({'Content-Type':'application/json' ,
    'Authorization': 'Bearer ' + this.authenticationService.token });//parametrizamos a json
  private options = new RequestOptions({ headers: this.headers });
  private url = this.URL.getLocal()+'/factura/reporte/fecha';//Url que maeja GET ,POST
  private urlInvByTienda = this.URL.getLocal()+'/factura/';//la direccion a la cual se conecta
  private urlPut = this.URL.getLocal()+'/Factura/';//la direccion a la cual se conecta
  private urlDetByid= this.URL.getLocal()+'/factura/';//la direccion a la cual se conecta
  private urlAnular = this.URL.getLocal()+'/factura/';//la direccion a la cual se conecta
  //Constructor de la clase
  constructor(private URL:UrlService,private http:Http, private authenticationService: AuthenticationService)
  {
    //this.headers.append('Content-Type', 'application/x-www-form-urlencoded');
    //this.headers.append('X-Requested-With', 'XMLHttpRequest');
  }
  //Obtiene una lista de Facturas
  getFactura():Observable<Factura[]> {
    let url = `${this.url}`;
    return this.http.get(url,this.options)
      .map(r => r.json())
      .catch(this.handleError)
  }
  getFacturaByFecha(datos:any): Observable<any[]> {
    let url = `${this.url}`;
    let iJson = JSON.stringify(datos);
    return this.http.post(url,iJson,this.options)
      .map(r => r.json())
      .catch(this.handleError);
  }
  getDetallesByPos(id: number): Observable<any[]> {
    let url = `${this.urlDetByid}${id}`;
    return this.http.get(url, this.options)
      .first()
      .map(r => r.json())
      .catch(this.handleError)
  }
  anularFactura(id: number): Observable<any[]> {
    let url = `${this.urlAnular}${id}`;
    return this.http.get(url, this.options)
      .first()
      .map(r => r.json())
      .catch(this.handleError)
  }

  addFactura(Factura:Factura) {
    let url = `${this.url}`;
    let iJson = JSON.stringify(Factura);
    return this.http.post(url,iJson,this.options)
      .map(r => r.json())
      .catch(this.handleError);

  }
  putFactura(Factura : Factura,id:number){
    let url = `${this.urlPut}${id}`;
    let CJson = JSON.stringify(Factura);
    return this.http.put(url,CJson,this.options)
      .map(r => r.json())
      .catch(this.handleError);
  }
//Este metodo detecta un error en la llamada a http
  private handleError(error : Response | any) {
    let errMsj : string;
    if(error instanceof Response)
    {
      let body  = error.json() || '';
      let err = body.error || JSON.stringify(body);
      errMsj = `${error.status} - ${error.statusText || ''} ${err}`;
    }
    else
    {
      errMsj = error.message ? error.message : error.Tostring();
    }
    return Observable.throw(errMsj);
  }
}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/Services/factura.service.ts